export default "__VITE_ASSET__D$PwT5Ga__"